import styled from 'styled-components';

const StyledStep = styled.section.attrs(() => ({
  className: '',
}))`
  display: flex;
  padding: 16px;
  border-top: ${(props) => (props.active ? 'none' : '1px solid #E6E6E6')};
  background-color: ${(props) => (props.active ? '#d9f1fb8a' : 'none')};

  & h2 {
    font-size: 18px;
    line-height: 24px;
    color: #383638;
    margin-right: 8px;
  }
  & span {
    color: #007db7;
    font-weight: 500;
    margin: 4px 4px 4px 0px;
  }
  & p {
    font-size: 14px;
    line-height: 20px;
    color: #383638;
  }
  & > article {
    flex: 0 1 auto;
  }
  & .cont-step-number {
    margin-right: 16px;
    & > div {
      display: flex;
      justify-content: center;
      align-items: center;
      color: ${(props) => (props.active ? 'white' : '#007DB7')};
      background-color: ${(props) => (props.active ? '#007DB7' : 'white')};
      border: 1px solid #007db7;
      border-radius: 50%;
      width: 32px;
      height: 32px;
    }
  }
  & .cont-step-img {
    display: flex;
    justify-content: center;
    align-items: center;
    & > div {
      justify-content: center;
      align-items: center;
      padding: 1rem;
      border: 0;
      border-radius: 50%;
      background-color: ${(props) => (props.active ? '#D9F1FB' : '#f6f6f6')};
    }
  }
  & > section {
    display: grid;
    flex: 1 1 auto;
    grid-gap: 4px;
    & article {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
    & p,
    & li {
      line-height: 20px;
    }
    & ul {
      list-style: none;
      padding-left: 16px;
      & li {
        line-height: 20px;
        margin-top: 8px;
      }
    }
    & ul li::before {
      content: '\\2022';
      color: #007db7;
      width: 1rem;
      margin-left: -1rem;
      font-weight: bold;
      display: inline-block;
    }
  }
`;

export default StyledStep;
